/**
 * BHT Mix & Match Bundle
 *
 * Dependencies:
 *   window.BHT_PRODUCT_DATA
 *   window.BHT_VARIANT_MAP
 *   window.BHT_ROUTES
 *
 * Prices remain integer cents throughout.
 */

(function () {
  'use strict';

  var BUNDLE_DISCOUNT_CENTS = 1000;

  var state = {
    1: {
      productKey: null,
      color: null,
      size: null,
      retailCents: null
    },
    2: {
      productKey: null,
      color: null,
      size: null,
      retailCents: null
    }
  };

  var submitting = false;

  var MONEY_FORMAT =
    window.money_format || '${{amount}}';

  function formatMoney(cents) {
    if (
      window.Shopify &&
      window.Shopify.formatMoney
    ) {
      return window.Shopify.formatMoney(
        cents,
        MONEY_FORMAT
      );
    }

    var dollars = Math.floor(cents / 100);
    var remainder = cents % 100;

    return (
      '$' +
      dollars +
      '.' +
      (remainder < 10 ? '0' : '') +
      remainder
    );
  }

  function el(id) {
    return document.getElementById(id);
  }

  function showField(element) {
    if (!element) return;

    element.classList.remove(
      'bht-mmb-field--hidden'
    );

    element.style.display = '';
  }

  function hideField(element) {
    if (!element) return;

    element.classList.add(
      'bht-mmb-field--hidden'
    );

    element.style.display = 'none';
  }

  function showError(message) {
    var errorEl = el('bht-error');

    if (!errorEl) return;

    errorEl.textContent = message;
    errorEl.style.display = 'block';
  }

  function clearError() {
    var errorEl = el('bht-error');

    if (!errorEl) return;

    errorEl.textContent = '';
    errorEl.style.display = 'none';
  }

  function setInputValue(id, value) {
    var input = el(id);

    if (input) {
      input.value = value;
    }
  }

  /* ─────────────────────────────
     PRICE DISPLAY
     ───────────────────────────── */

  function updatePriceDisplay() {
    var s1 = state[1];
    var s2 = state[2];

    var bundlePriceEl =
      el('bht-bundle-price');

    var comparePriceEl =
      el('bht-compare-price');

    var savingsEl =
      el('bht-savings');

    if (!bundlePriceEl) return;

    if (
      s1.retailCents !== null &&
      s2.retailCents !== null
    ) {
      var combinedRetail =
        s1.retailCents +
        s2.retailCents;

      var bundlePrice =
        combinedRetail -
        BUNDLE_DISCOUNT_CENTS;

      bundlePriceEl.textContent =
        formatMoney(bundlePrice);

      if (comparePriceEl) {
        comparePriceEl.textContent =
          formatMoney(combinedRetail);
      }

      if (savingsEl) {
        savingsEl.style.display = '';
      }
    } else {
      bundlePriceEl.textContent = '';

      if (comparePriceEl) {
        comparePriceEl.textContent = '';
      }

      if (savingsEl) {
        savingsEl.style.display = 'none';
      }
    }
  }

  /* ─────────────────────────────
     ATC BUTTON
     ───────────────────────────── */

  function updateATCButton() {
    var btn = el('bht-atc-btn');

    if (!btn) return;

    var s1 = state[1];
    var s2 = state[2];

    var complete =
      s1.productKey &&
      s1.color &&
      s1.size &&
      s2.productKey &&
      s2.color &&
      s2.size;

    btn.disabled =
      !complete || submitting;
  }

  /* ─────────────────────────────
     NATIVE VARIANT RESOLUTION
     ───────────────────────────── */

  function resolveVariantId() {
    var s1 = state[1];
    var s2 = state[2];

    if (
      s1.retailCents === null ||
      s2.retailCents === null
    ) {
      return null;
    }

    var combinedRetail =
      s1.retailCents +
      s2.retailCents;

    var variantMap =
      window.BHT_VARIANT_MAP || {};

    var variantId =
      variantMap[combinedRetail];

    return (
      variantId !== undefined &&
      variantId !== null
    )
      ? variantId
      : null;
  }

  function syncVariantInput() {
    var input =
      document.querySelector(
        '#bht-mmb-form input[name="id"]'
      );

    if (!input) return;

    var variantId =
      resolveVariantId();

    input.value =
      variantId !== null
        ? variantId
        : '';
  }

  /* ─────────────────────────────
     COLORS
     ───────────────────────────── */

  function renderColors(
    itemNum,
    productKey
  ) {
    var container =
      el(
        'bht-item' +
        itemNum +
        '-swatches'
      );

    var colorField =
      el(
        'bht-item' +
        itemNum +
        '-color-field'
      );

    if (!container) return;

    container.innerHTML = '';

    var data =
      (
        window.BHT_PRODUCT_DATA ||
        {}
      )[productKey];

    if (
      !data ||
      !data.colorMap
    ) {
      hideField(colorField);
      return;
    }

    var colors =
      Object.keys(data.colorMap);

    if (colors.length === 0) {
      hideField(colorField);
      return;
    }

    colors.forEach(
      function (color) {
        var btn =
          document.createElement(
            'button'
          );

        btn.type = 'button';
        btn.className =
          'bht-mmb-swatch';

        btn.setAttribute(
          'data-color',
          color
        );

        btn.setAttribute(
          'role',
          'radio'
        );

        btn.setAttribute(
          'aria-checked',
          'false'
        );

        btn.setAttribute(
          'aria-label',
          color
        );

        btn.setAttribute(
          'title',
          color
        );

        var inner =
          document.createElement(
            'span'
          );

        inner.className =
          'bht-mmb-swatch__inner';

        btn.appendChild(inner);

        btn.addEventListener(
          'click',
          function () {
            onColorSelect(
              itemNum,
              color,
              productKey
            );
          }
        );

        container.appendChild(btn);
      }
    );

    showField(colorField);
  }

  /* ─────────────────────────────
     SIZES
     ───────────────────────────── */

  function renderSizes(
    itemNum,
    productKey,
    color
  ) {
    var container =
      el(
        'bht-item' +
        itemNum +
        '-sizes'
      );

    var sizeField =
      el(
        'bht-item' +
        itemNum +
        '-size-field'
      );

    var selectedSizeEl =
      el(
        'bht-item' +
        itemNum +
        '-selected-size'
      );

    if (!container) return;

    container.innerHTML = '';

    if (selectedSizeEl) {
      selectedSizeEl.textContent = '';
    }

    var data =
      (
        window.BHT_PRODUCT_DATA ||
        {}
      )[productKey];

    if (
      !data ||
      !data.colorMap ||
      !data.colorMap[color]
    ) {
      hideField(sizeField);
      return;
    }

    var sizeMap =
      data.colorMap[color];

    var sizes =
      Object.keys(sizeMap);

    if (sizes.length === 0) {
      hideField(sizeField);
      return;
    }

    sizes.forEach(
      function (size) {
        var btn =
          document.createElement(
            'button'
          );

        btn.type = 'button';
        btn.className =
          'bht-mmb-size-btn';

        btn.textContent = size;

        btn.setAttribute(
          'data-size',
          size
        );

        btn.setAttribute(
          'role',
          'radio'
        );

        btn.setAttribute(
          'aria-checked',
          'false'
        );

        btn.addEventListener(
          'click',
          function () {
            onSizeSelect(
              itemNum,
              size,
              sizeMap[size]
            );
          }
        );

        container.appendChild(btn);
      }
    );

    showField(sizeField);
  }

  /* ─────────────────────────────
     PRODUCT SELECTION
     ───────────────────────────── */

  function onProductSelect(
    itemNum,
    productKey
  ) {
    state[itemNum] = {
      productKey:
        productKey || null,

      color: null,
      size: null,
      retailCents: null
    };

    clearColorSelection(itemNum);
    clearSizeSelection(itemNum);

    hideField(
      el(
        'bht-item' +
        itemNum +
        '-size-field'
      )
    );

    if (productKey) {
      renderColors(
        itemNum,
        productKey
      );
    } else {
      hideField(
        el(
          'bht-item' +
          itemNum +
          '-color-field'
        )
      );
    }

    syncVariantInput();
    updatePriceDisplay();
    updateATCButton();
    clearError();
  }

  function onColorSelect(
    itemNum,
    color,
    productKey
  ) {
    state[itemNum].color =
      color;

    state[itemNum].size =
      null;

    state[itemNum].retailCents =
      null;

    var swatchContainer =
      el(
        'bht-item' +
        itemNum +
        '-swatches'
      );

    if (swatchContainer) {
      swatchContainer
        .querySelectorAll(
          '.bht-mmb-swatch'
        )
        .forEach(
          function (btn) {
            var isThis =
              btn.getAttribute(
                'data-color'
              ) === color;

            btn.classList.toggle(
              'is-selected',
              isThis
            );

            btn.setAttribute(
              'aria-checked',
              isThis
                ? 'true'
                : 'false'
            );
          }
        );
    }

    var selectedSizeEl =
      el(
        'bht-item' +
        itemNum +
        '-selected-size'
      );

    if (selectedSizeEl) {
      selectedSizeEl.textContent =
        '';
    }

    clearSizeSelection(itemNum);

    renderSizes(
      itemNum,
      productKey,
      color
    );

    syncVariantInput();
    updatePriceDisplay();
    updateATCButton();
    clearError();
  }

  function onSizeSelect(
    itemNum,
    size,
    retailCents
  ) {
    state[itemNum].size =
      size;

    state[itemNum].retailCents =
      retailCents;

    var sizeContainer =
      el(
        'bht-item' +
        itemNum +
        '-sizes'
      );

    if (sizeContainer) {
      sizeContainer
        .querySelectorAll(
          '.bht-mmb-size-btn'
        )
        .forEach(
          function (btn) {
            var isThis =
              btn.getAttribute(
                'data-size'
              ) === size;

            btn.classList.toggle(
              'is-selected',
              isThis
            );

            btn.setAttribute(
              'aria-checked',
              isThis
                ? 'true'
                : 'false'
            );
          }
        );
    }

    var selectedSizeEl =
      el(
        'bht-item' +
        itemNum +
        '-selected-size'
      );

    if (selectedSizeEl) {
      selectedSizeEl.textContent =
        '— ' + size;
    }

    syncVariantInput();
    updatePriceDisplay();
    updateATCButton();
    clearError();
  }

  function clearColorSelection(
    itemNum
  ) {
    var container =
      el(
        'bht-item' +
        itemNum +
        '-swatches'
      );

    if (!container) return;

    container
      .querySelectorAll(
        '.bht-mmb-swatch'
      )
      .forEach(
        function (btn) {
          btn.classList.remove(
            'is-selected'
          );

          btn.setAttribute(
            'aria-checked',
            'false'
          );
        }
      );
  }

  function clearSizeSelection(
    itemNum
  ) {
    var container =
      el(
        'bht-item' +
        itemNum +
        '-sizes'
      );

    if (!container) return;

    container
      .querySelectorAll(
        '.bht-mmb-size-btn'
      )
      .forEach(
        function (btn) {
          btn.classList.remove(
            'is-selected'
          );

          btn.setAttribute(
            'aria-checked',
            'false'
          );
        }
      );
  }

  /* ─────────────────────────────
     FULFILLMENT PROPERTIES
     ───────────────────────────── */

  function writeFulfillmentProperties() {
    var data =
      window.BHT_PRODUCT_DATA || {};

    var s1 = state[1];
    var s2 = state[2];

    var d1 =
      data[s1.productKey] || {};

    var d2 =
      data[s2.productKey] || {};

    setInputValue(
      'bht-prop-item1-product',
      d1.label || ''
    );

    setInputValue(
      'bht-prop-item1-underlying',
      d1.underlying || ''
    );

    setInputValue(
      'bht-prop-item1-color',
      s1.color || ''
    );

    setInputValue(
      'bht-prop-item1-size',
      s1.size || ''
    );

    setInputValue(
      'bht-prop-item2-product',
      d2.label || ''
    );

    setInputValue(
      'bht-prop-item2-underlying',
      d2.underlying || ''
    );

    setInputValue(
      'bht-prop-item2-color',
      s2.color || ''
    );

    setInputValue(
      'bht-prop-item2-size',
      s2.size || ''
    );
  }

  /* ─────────────────────────────
     ADD TO CART
     ───────────────────────────── */

  function onFormSubmit(event) {
    event.preventDefault();

    if (submitting) return;

    var btn =
      el('bht-atc-btn');

    var s1 = state[1];
    var s2 = state[2];

    clearError();

    if (
      !s1.productKey ||
      !s1.color ||
      !s1.size ||
      !s2.productKey ||
      !s2.color ||
      !s2.size
    ) {
      showError(
        'Please complete both Item 1 and Item 2 selections before adding to cart.'
      );

      return;
    }

    var combinedRetailCents =
      s1.retailCents +
      s2.retailCents;

    var variantMap =
      window.BHT_VARIANT_MAP || {};

    var variantId =
      variantMap[
        combinedRetailCents
      ];

    if (!variantId) {
      showError(
        'Bundle pricing is not configured for this combination. Please refresh and try again.'
      );

      return;
    }

    var variantInput =
      document.querySelector(
        '#bht-mmb-form input[name="id"]'
      );

    if (!variantInput) {
      showError(
        'An unexpected error occurred. Please refresh and try again.'
      );

      return;
    }

    variantInput.value =
      variantId;

    writeFulfillmentProperties();

    submitting = true;

    if (btn) {
      btn.disabled = true;

      btn.classList.add(
        'is-loading'
      );

      btn.textContent =
        'Adding…';
    }

    var productData =
      window.BHT_PRODUCT_DATA || {};

    var d1 =
      productData[
        s1.productKey
      ] || {};

    var d2 =
      productData[
        s2.productKey
      ] || {};

    var payload = {
      items: [
        {
          id: variantId,
          quantity: 1,

          properties: {
            'Item 1 Product':
              d1.label || '',

            'Item 1 Underlying Product':
              d1.underlying || '',

            'Item 1 Color':
              s1.color || '',

            'Item 1 Size':
              s1.size || '',

            'Item 2 Product':
              d2.label || '',

            'Item 2 Underlying Product':
              d2.underlying || '',

            'Item 2 Color':
              s2.color || '',

            'Item 2 Size':
              s2.size || ''
          }
        }
      ]
    };

    fetch(
      window.BHT_ROUTES.cart_add,
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          'Accept':
            'application/json'
        },

        body:
          JSON.stringify(payload)
      }
    )
      .then(
        function (response) {
          if (!response.ok) {
            return response
              .json()
              .then(
                function (errData) {
                  throw new Error(
                    errData.description ||
                    errData.message ||
                    'Could not add to cart.'
                  );
                }
              );
          }

          return response.json();
        }
      )
      .then(
        function () {
          window.location.href =
            window.BHT_ROUTES
              .cart_url;
        }
      )
      .catch(
        function (err) {
          console.error(
            '[BHT Bundle] ATC error:',
            err
          );

          submitting = false;

          if (btn) {
            btn.disabled = false;

            btn.classList.remove(
              'is-loading'
            );

            btn.textContent =
              'Add Bundle to Cart';
          }

          updateATCButton();

          showError(
            err.message ||
            'There was a problem adding to cart. Please try again.'
          );
        }
      );
  }

  /* ─────────────────────────────
     IMAGE GALLERY
     ───────────────────────────── */

  function initThumbnailGallery() {
    var mainImage =
      el('bht-main-image');

    if (!mainImage) return;

    document
      .querySelectorAll(
        '.bht-mmb-thumb'
      )
      .forEach(
        function (thumb) {
          thumb.addEventListener(
            'click',
            function () {
              var newSrc =
                thumb.getAttribute(
                  'data-bht-thumb-src'
                );

              var newAlt =
                thumb.getAttribute(
                  'data-bht-thumb-alt'
                );

              if (newSrc) {
                mainImage.src =
                  newSrc;
              }

              if (newAlt) {
                mainImage.alt =
                  newAlt;
              }

              document
                .querySelectorAll(
                  '.bht-mmb-thumb'
                )
                .forEach(
                  function (t) {
                    t.classList.remove(
                      'is-active'
                    );
                  }
                );

              thumb.classList.add(
                'is-active'
              );
            }
          );
        }
      );
  }

  /* ─────────────────────────────
     DESCRIPTION
     ───────────────────────────── */

  function initDescriptionAccordion() {
    var toggle =
      document.querySelector(
        '.bht-mmb-desc-toggle'
      );

    var body =
      el('bht-desc-body');

    if (!toggle || !body) {
      return;
    }

    toggle.addEventListener(
      'click',
      function () {
        var isExpanded =
          toggle.getAttribute(
            'aria-expanded'
          ) === 'true';

        toggle.setAttribute(
          'aria-expanded',
          isExpanded
            ? 'false'
            : 'true'
        );

        if (isExpanded) {
          body.setAttribute(
            'hidden',
            ''
          );
        } else {
          body.removeAttribute(
            'hidden'
          );
        }
      }
    );
  }

  /* ─────────────────────────────
     INIT
     ───────────────────────────── */

  function init() {
    if (
      !window.BHT_PRODUCT_DATA
    ) {
      console.error(
        '[BHT Bundle] BHT_PRODUCT_DATA missing.'
      );

      return;
    }

    if (
      !window.BHT_ROUTES ||
      !window.BHT_ROUTES.cart_add ||
      !window.BHT_ROUTES.cart_url
    ) {
      console.error(
        '[BHT Bundle] BHT_ROUTES missing or incomplete.'
      );

      return;
    }

    if (
      !window.BHT_VARIANT_MAP ||
      Object.keys(
        window.BHT_VARIANT_MAP
      ).length !== 25
    ) {
      console.warn(
        '[BHT Bundle] Expected 25 pricing variants in BHT_VARIANT_MAP.'
      );
    }

    [1, 2].forEach(
      function (itemNum) {
        var select =
          document.querySelector(
            '[data-bht-product-select="' +
            itemNum +
            '"]'
          );

        if (select) {
          select.addEventListener(
            'change',
            function () {
              onProductSelect(
                itemNum,
                select.value || null
              );
            }
          );
        }
      }
    );

    var form =
      el('bht-mmb-form');

    if (form) {
      form.addEventListener(
        'submit',
        onFormSubmit
      );
    }

    initThumbnailGallery();
    initDescriptionAccordion();

    updatePriceDisplay();
    updateATCButton();
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
}());